/* Rims4Italy theme.js */
(function () {
  // Mobile nav toggle
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-nav-toggle]');
    if (toggle) {
      var nav = document.getElementById('MobileNav');
      if (nav) {
        var isOpen = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }
    }
    // close when a mobile link is tapped
    if (e.target.closest('.mobile-nav a')) {
      var open = document.querySelector('.mobile-nav.is-open');
      if (open) open.classList.remove('is-open');
      var btn = document.querySelector('[data-nav-toggle]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }
  });

  // Smooth scroll for in-page category anchors
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var id = link.getAttribute('href');
    if (id.length < 2) return;
    var target = document.getElementById(decodeURIComponent(id.slice(1)));
    if (target) {
      e.preventDefault();
      var smooth = !window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
    }
  });
})();

/* Scroll reveal — cascades sections/cards in as you scroll up or down */
(function () {
  var root = document.documentElement;
  if (!('IntersectionObserver' in window)) { root.classList.remove('reveal'); return; }

  var SEL = '.section-head, .wheel-card, .cat-card, .faq-item, .wheel-divider, .contact-band__head, .contact-grid, .newsletter-form';
  var items = Array.prototype.slice.call(document.querySelectorAll(SEL));
  if (!items.length) { root.classList.remove('reveal'); return; }

  items.forEach(function (el) {
    el.classList.add('reveal-item');
    // stagger items that sit in the same row/grid
    var parent = el.parentElement;
    if (parent) {
      var group = Array.prototype.slice.call(parent.children).filter(function (c) { return c.matches(SEL); });
      var idx = group.indexOf(el);
      if (idx > 0) el.style.transitionDelay = Math.min(idx * 70, 420) + 'ms';
    }
  });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) en.target.classList.add('is-in');
      else en.target.classList.remove('is-in'); // re-trigger when scrolling back
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  items.forEach(function (el) { io.observe(el); });

  // failsafe: reveal anything still hidden but already on-screen after load
  window.addEventListener('load', function () {
    setTimeout(function () {
      document.querySelectorAll('.reveal-item:not(.is-in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < innerHeight && r.bottom > 0) el.classList.add('is-in');
      });
    }, 700);
  });
})();
